import type { TClaimStatus, TClaimLineItemStatus } from '@/@types/claims';

// Match exact colors from ClaimsListPage status badges
export const STATUS_BADGE_VARIANT: Record<
  TClaimStatus,
  'default' | 'secondary' | 'destructive' | 'outline'
> = {
  draft: 'outline',
  submitted: 'outline',
  under_review: 'outline',
  additional_info_required: 'outline',
  approved: 'outline',
  partially_approved: 'outline',
  rejected: 'outline',
  paid: 'outline',
  partially_paid: 'outline',
};

export const STATUS_BADGE: Record<TClaimStatus, string> = {
  draft: 'bg-status-archived-bg text-status-archived border-status-archived-border',
  submitted: 'bg-claim-submitted-bg text-claim-submitted border-claim-submitted-border',
  under_review: 'bg-claim-under-review-bg text-claim-under-review border-claim-under-review-border',
  additional_info_required:
    'bg-claim-info-required-bg text-claim-info-required border-claim-info-required-border',
  approved: 'bg-claim-approved-bg text-claim-approved border-claim-approved-border',
  partially_approved: 'bg-claim-approved-bg text-claim-approved border-claim-approved-border',
  rejected: 'bg-claim-rejected-bg text-claim-rejected border-claim-rejected-border',
  paid: 'bg-claim-paid-bg text-claim-paid border-claim-paid-border',
  partially_paid: 'bg-claim-paid-bg text-claim-paid border-claim-paid-border',
};

export const LINE_ITEM_STATUS_BADGE_VARIANT: Record<
  TClaimLineItemStatus,
  'default' | 'secondary' | 'destructive' | 'outline'
> = {
  pending: 'outline',
  approved: 'outline',
  rejected: 'outline',
  paid: 'outline',
};

export const LINE_ITEM_STATUS_BADGE: Record<TClaimLineItemStatus, string> = {
  pending: 'bg-claim-under-review-bg text-claim-under-review border-claim-under-review-border',
  approved: 'bg-claim-approved-bg text-claim-approved border-claim-approved-border',
  rejected: 'bg-claim-rejected-bg text-claim-rejected border-claim-rejected-border',
  paid: 'bg-claim-paid-bg text-claim-paid border-claim-paid-border',
};

export const STATUS_TRANSITIONS: Record<TClaimStatus, TClaimStatus[]> = {
  draft: ['submitted'],
  submitted: ['under_review', 'rejected'],
  under_review: ['additional_info_required', 'approved', 'partially_approved', 'rejected'],
  additional_info_required: ['under_review'],
  approved: ['paid', 'partially_paid'],
  partially_approved: ['paid', 'partially_paid'],
  rejected: [],
  paid: [],
  partially_paid: [],
};

export function formatMoney(amount: number | undefined, currency: string | undefined): string {
  if (amount === undefined || amount === null) return '—';
  const prefix = currency ?? '';
  return `${prefix} ${amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`.trim();
}

export function formatDate(ts: number | undefined | null): string {
  if (ts === undefined || ts === null || ts === 0 || isNaN(ts)) return '—';
  const date = new Date(ts);
  if (isNaN(date.getTime())) return '—';
  return date.toLocaleDateString();
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
